import React, { useState, useEffect } from "react";
import SearchBarComponent from "components/customs/searchbarV2";
import { defaultTableOption } from "constants/table";
import CustomDataTable from "components/customs/table";
import { getFormattedNumber } from "utility/helpers";
import styled from "styled-components";
import AddEndorsementColumns from "./columns";

const AddCourseTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1rem;

  .custom-searchbar-container input {
    box-shadow: initial;
  }
`;

const AddCourseTableContainer = styled.div`
  .form-control {
    border-radius: 0.375rem !important;
    height: unset !important;
  }
`;

const AddCourseTbl = styled.div`
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  border-top: solid #cecece 1px;
  border-bottom: solid #cecece 1px;
`;

const NumberOfCoursesText = styled.span`
  letter-spacing: 0.1rem;
  font-weight: 600;
`;

const TotalAbscapText = styled.span`
  float: inline-end;
  letter-spacing: 0.1rem;
  font-weight: 600;
`;

const TableHeaderText = styled.h5`
  margin: 0;
`;

const SearchbarWrapper = styled.div`
  position: relative;

  input {
    box-shadow: none;
    border-radius: 9px;
    height: clamp(35px, 5vw, 50px);
  }
`;

const AddCourseTable = ({ data, setCourses, setForm, courses, action }) => {
  const [tableOption, setTableOption] = useState(defaultTableOption);

  let changeSearchTimeoutID;

  const onChangeSearch = (event) => {
    event.persist();

    if (changeSearchTimeoutID) {
      clearTimeout(changeSearchTimeoutID);
    }

    changeSearchTimeoutID = setTimeout(() => {
      const eventValue = event.target.value.trim();

      if (eventValue.length !== 0) {
        const dataTable = tableOption.data.filter((item) =>
          item?.course?.toLowerCase()?.includes(eventValue)
        );

        setTableOption({
          ...tableOption,
          data: dataTable,
        });
      } else {
        setTableOption({
          ...tableOption,
          data,
        });
      }
    }, 1000);
  };

  const toggleCourseSelection = (row, checked) => {
    setCourses((prevCourses) => {
      let updatedCourses = prevCourses.filter(
        (course) => course.tviCourseId !== row.tviCourseId
      );

      if (checked) {
        updatedCourses = [
          ...updatedCourses,
          {
            tviCourseId: row.tviCourseId,
            slots: 0,
            ...(row.id != null ? { id: row.id } : {}),
          },
        ];
      }

      return updatedCourses;
    });
  };

  const updateSlots = (id, value) => {
    setCourses((prevCourses) =>
      prevCourses.map((course) =>
        course.tviCourseId === id ? { ...course, slots: Number(value) } : course
      )
    );
  };

  // Calculate totals using courses array only
  const totalSlots = courses.reduce(
    (sum, course) => sum + Number(course.slots),
    0
  );

  const totalEstimatedCost = courses.reduce((sum, course) => {
    // Lookup course data using courseId
    const courseData = data.find(
      (item) => item.tviCourseId === course.tviCourseId
    );
    const cost = courseData ? Number(courseData.totalCost) || 0 : 0;
    const slots = Number(course.slots) || 0;

    return sum + cost * slots;
  }, 0);

  const isAllChecked = React.useMemo(() => {
    return (courses?.length === data?.length && courses?.length > 0) ?? false;
  }, [courses, data]);

  const handleBulkCheckboxOnChange = (evt) => {
    const { checked } = evt.target;
    const newData = data.filter((course) => course.availableSlots > 0);
    const newCourses = checked ? newData : [];

    setCourses(newCourses);
  };

  useEffect(() => {
    if (setForm) {
      setForm((prevForm) => ({
        ...prevForm,
        budget: totalEstimatedCost,
      }));
    }
  }, [totalEstimatedCost, setForm]);

  const columns = AddEndorsementColumns({
    handleBulkCheckboxOnChange,
    isAllChecked,
    action,
    courses,
    toggleCourseSelection,
    updateSlots,
  });

  useEffect(() => {
    if (data) {
      setTableOption({
        ...tableOption,
        data,
      });
    }
  }, [data]);

  return (
    <AddCourseTbl>
      <AddCourseTableHeader>
        <TableHeaderText>{"Add Courses to this TVI"}</TableHeaderText>

        <SearchbarWrapper>
          <SearchBarComponent
            onChangeSearch={onChangeSearch}
            isDisabled={tableOption?.isLoading}
          />
        </SearchbarWrapper>
      </AddCourseTableHeader>

      <AddCourseTableContainer>
        <CustomDataTable
          columns={columns}
          data={tableOption.data}
          noHeader
          progressPending={tableOption.isLoading}
          height="calc(100vh - 200px)"
          paginationPerPage={50}
          paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
        />

        <div>
          <NumberOfCoursesText>
            {`Total Slots: ${totalSlots}`}
          </NumberOfCoursesText>
          <TotalAbscapText>{`Total Estimated Cost: ${getFormattedNumber(
            totalEstimatedCost ?? 0
          )}`}</TotalAbscapText>
        </div>
      </AddCourseTableContainer>
    </AddCourseTbl>
  );
};

export default AddCourseTable;
